import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/sections/Hero";
import KeyLine from "@/sections/KeyLine";
import Marquee from "@/sections/Marquee";
import Architecture from "@/sections/Architecture";
import ArchitectureMobile from "@/sections/ArchitectureMobile";
import Evidence from "@/sections/Evidence";
import Capabilities from "@/sections/Capabilities";
import FinalCTA from "@/sections/FinalCTA";
import TwinButterfly from "@/components/TwinButterfly";
import useMediaQuery from "@/hooks/useMediaQuery";

const Home = () => {
  const { hash } = useLocation();
  const flowDesktop = useMediaQuery(
    "(min-width: 768px) and (min-aspect-ratio: 1/1)"
  );

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [hash]);

  return (
    <main data-testid="home-page" className="relative z-10">
      <TwinButterfly />
      <Hero />
      <KeyLine />
      <Marquee />
      {flowDesktop ? <Architecture /> : <ArchitectureMobile />}
      <Evidence />
      <Capabilities />
      <FinalCTA />
    </main>
  );
};

export default Home;
